<template>
  <div
    id="taktplan" 
    class="taktplan" 
    :style="`width: calc(100% - ${getSideBarWidth()}); scroll-behavior: smooth`" 
    color="color-1"
    ref="taktplan" 
    @mousemove="
     moveTaktareaStartMouseMove($event), moveTrainStartMouseMove($event), flexBarHeightMouseMove($event), 
     moveTaktPlanMouseMove($event)
    " 
    @mouseup="moveTaktareaStartMouseUp(), moveTrainStartMouseUp(), flexBarHeightMouseUp()" 
    @mouseleave="moveTaktareaStartMouseUp(), moveTrainStartMouseUp(), flexBarHeightMouseUp()" 
    @mousedown="moveTaktPlanMouseDown($event)" 
    @touchmove="flexBarHeightMouseMove($event)"
    @touchend="flexBarHeightMouseUp()" 
    @touchcancel="flexBarHeightMouseUp()"
    >
    <!-- @click.self="routeToTaktplan()" -->

    <!-- AUTOPILOT TEST -->
    <!-- <StandardDialog v-if="getAutopilots.length" @click-outside="clearAutopilots()" style="z-index: 30">
      <template #content>
        <div class="pa-5">
          <h2>AUTO.pilot messages</h2>
          <span v-for="(ap, index) in getAutopilots" :key="'apindex'+index">
            <div v-for="(ap_msg, msg_index) in ap.messages" :key="'msg_index'+msg_index">
              <b v-if="ap.blocking">{{ap_msg}}</b>
              <i v-else>{{ap_msg}}</i>
            </div>
          </span>
          <v-btn @click="clearAutopilots()" class="mt-5" color="green">Dismiss</v-btn>
        </div>
      </template>
    </StandardDialog> -->
    <PrintDialog v-if="$store.state.View.is_printing_mode" name="Taktplan" :file_name="project.name"
      print_el="taktplan-container" height_el="taktplan-container" width_el="statistics-container"
      legend_el="legend-container" />
      
      <!-- IFC SNACKBAR -->
      <!-- applySnackbarIFC -->
      <transition name="snack-bar-slide-y">
        <SnackBar v-if="snackbar_ifc.show" :snackbar="snackbar_ifc" @updateSnackbar="updateSnackbarIFC($event)">

          <template #activator>
            <Activator class="self-centered cursor-s-resize" :key="`snackbar_activator`"
              @mousedown.native="updateSnackbarIFC({ show: false, hover: false, selector: false })" />
          </template>

          <template #header>
            <div class="takt-plan-snack-bar-head">
              <TText text="Scale linking to all TAKT.areas" />
            </div>
          </template>

          <template #body>
            <div style="display:flex;flex-direction: column;">
              <SnackBarStepItem 
                :step="getUObject({ type: 'tworksteps', id: snackbar_ifc.tworkstep_id})" 
                step_type="Work" 
                :background_color="getUObjectParent({
                  parent_type: 'tworkpackages',
                  type: 'tworksteps',
                  id: snackbar_ifc.tworkstep_id
                }).color" 
                :foreground_color="getUObjectParent({
                  parent_type: 'tworkpackages',
                  type: 'tworksteps',
                  id: snackbar_ifc.tworkstep_id
                }).textcolor" 
              />
              <div style="display:flex;grid-gap: 4px;">
                <TText :value="snackbar_ifc.action" />
                <TText value="elements with the following conditions" />
                <TText :value="snackbar_ifc.action === 'add' ? 'to': 'from'" />
                <TText value="WORK.step:" />
              </div>

              <div v-for="condition_key in Object.keys(snackbar_ifc.conditions[0])" :key="`elements_condition${condition_key}`">
                <div style="display:flex;grid-gap: 4px;">
                  <TText :value="condition_key" />
                  <TText :value="snackbar_ifc.conditions[0][condition_key].operator" />
                  <TText :value="snackbar_ifc.conditions[0][condition_key].value" />
                </div>
              </div>
            </div>
          </template>

          <template #footer>
            <div class="takt-plan-snack-bar-footer">
              <div class="takt-plan-snack-bar-footer-buttons">
              <ButtonOutlined text="Close"
                  @buttonClicked="updateSnackbarIFC({ show: false, hover: false, affected_additional_targets: false, bim_process: false, response_elements: false, selector: false })" />
                <ButtonOutlined 
                  :text="`Apply (${snackbar_ifc_element_count})`"
                  color="green lighten-1" @buttonClicked="applySnackbarIFC()" />
              </div>
            </div>
          </template>

        </SnackBar>
      </transition>
      
      
    <!-- width_el="takt-plan-train-container" -->
    <transition name="snack-bar-slide-y">
      <!-- SnackBar -->
      <SnackBar v-if="snackbar.show" :snackbar="snackbar" @updateSnackbar="updateSnackbar($event)">
        <!-- @clickSnackBar="snackBarBulk()" -->
        <!-- SBACKBAR ACTIVATOR -->
        <template #activator>
          <Activator class="self-centered cursor-s-resize" :key="`snackbar_activator`"
            @mousedown.native="updateSnackbar({ show: false, hover: false, selector: false })" />
        </template>

        <!-- SNACKBAR HEADER -->
        <template #header>
          <template v-if="snackbar.action === 'create'">

            <!-- snackbar for creating elements in work steps -->
            <div class="takt-plan-snack-bar-head">
              <template v-if="snackbar.target_type === 'tworksteps' && snackbar.affected_additional_targets">
                <TText text="Create element in all" />
                <TWorkPackage class="ma-2" :workpackage_count="1" :zoom="1" :workpackage="snackbar.parent_cache" />
                <TText text="for WORK.step:" />
              </template>
              <template v-else>
                <div style="display: flex; flex-direction: column">
                  <div style="display: flex; justify-content: center; align-items: center">
                    <TText v-if="!snackbar.reference" text="Create in all" />
                    <TText v-else-if="snackbar.reference.before" text="Create Waggon before all" />
                    <TText v-else text="Create Waggon after all" />
                    <TWorkPackage v-if="snackbar.target_type.substring(snackbar.target_type.length - 5) === 'steps'"
                      class="ma-2" :workpackage_count="1" :zoom="1/*0.7*/" :workpackage="snackbar.parent_cache" />
                    <TWaggon v-else-if="['twaggons', 'tworkpackages'].includes(snackbar.target_type)" class="ma-2"
                      :workpackage_count="snackbar.target_type === 'tworkpackages'
                        ? snackbar.parent_cache.tworkpackages.length
                        : getUObject({ type: 'twaggons', id: snackbar.reference.id }).tworkpackages.length" :waggon="snackbar.target_type === 'tworkpackages'
                        ? snackbar.parent_cache
                        : getUObject({ type: 'twaggons', id: snackbar.reference.id })">
                      <template #content="{ waggon }">
                        <TWorkPackage v-for="workpackage in getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages })"
                          :key="`movewaggonworkpackage${workpackage.id}`" :workpackage_count="waggon.tworkpackages.length"
                          :workpackage="workpackage" />
                      </template>
                    </TWaggon>
                <TText text="in train:" />
                  </div>
                  
                <div
                v-if="['steps'].includes(snackbar.target_type.substring(snackbar.target_type.length - 5))">
                  <div style="display: flex; gap: 5px">
                    <div v-for="init_filter in snackbar.init_filter" :key="init_filter">
                      <ToggleCapsule  :is_active="snackbar.filter.includes(init_filter)" foreground_color="green lighten-1"
                      background_color="primary" border_color="primary" knob_color="primary"
                      @toggleClicked="updateSnackbarFiltered(init_filter)" />
                      <TText :text="init_filter" />
                    </div>
                    
                      <ButtonOutlined text="Filter"
                        @buttonClicked="requestSnackbarFiltered({ project_id, snackbar })" />
                  </div>
                </div>
              </div>
              </template>
            </div>
          </template>

          <template
            v-else-if="snackbar.action === 'update' || snackbar.target_type.substring(snackbar.target_type.length - 5) === 'steps'">
            <div class="takt-plan-snack-bar-head">
              <template v-if="snackbar.bim_process">
                <div style="display: flex; flex-direction: column;">
                  <TText value="Apply this change in all elements in train with conditions:" />
                  <TText v-for="condition in snackbar.conditions" :key="`condition${Object.keys(condition)[0]}`"
                    :text="Object.keys(condition)[0] + ' ' + condition[Object.keys(condition)[0]].operator + ' ' + condition[Object.keys(condition)[0]].value" />
                </div>
              </template>
              <div
                v-else-if="['kages', 'steps'].includes(snackbar.target_type.substring(snackbar.target_type.length - 5))">
                <div style="display: flex; flex-direction: column">
                  <div style="display: flex; justify-content: center; align-items: center">
                    <TText text="Apply this change in all" />
                    <TWorkPackage class="ml-2 mr-2" :workpackage_count="1/*0.7*/" :zoom="1" :workpackage="getUObject({
                      type: 'tworkpackages',
                      id: snackbar.target_type === 'tworkpackages' ? snackbar.target_id : snackbar.parent_id
                    })" :hide_token="!snackbar.filter.includes('token')" :hide_color="!snackbar.filter.includes('color')" :hide_icon="!snackbar.filter.includes('icon')" />
                    <TText text="in train by" />
                
                  </div>
               
                  <div style="display: flex; gap: 5px">
                    <div v-for="init_filter in snackbar.init_filter" :key="init_filter">
                      <ToggleCapsule  :is_active="snackbar.filter.includes(init_filter)" foreground_color="green lighten-1"
                      background_color="primary" border_color="primary" knob_color="primary"
                      @toggleClicked="updateSnackbarFiltered(init_filter)" />
                      <TText :text="init_filter" />
                    </div>
                    
                      <ButtonOutlined text="Apply Filter" small
                        @buttonClicked="requestSnackbarFiltered({ project_id, snackbar })" />
                  </div>
                </div>
              </div>

              <div v-else>
                <TText text="Apply this change in all wagons in train:" />
              </div>
            </div>
          </template>

          <!-- NOTE could be better -->
          <template v-else-if="snackbar.action === 'updateposition'">
            <div class="takt-plan-snack-bar-head">
              <TText :text="getUpdatePositionText()" />
            </div>
          </template>

          <template v-else-if="snackbar.action === 'updateparent'">
            <div class="takt-plan-snack-bar-head">
              <TText text="Move" />
              <TWorkPackage class="ml-2 mr-2" :workpackage_count="1" :zoom="1 /*0.7*/" :workpackage="getUObject({
                type: 'tworkpackages',
                id: snackbar.target_id
              })" />
              <TText text="in all Taktareas in train:" />
            </div>
          </template>

          <template v-else-if="snackbar.action === 'updatetaktareastart'">
            <div class="takt-plan-snack-bar-head">
              <TText text="Apply this change in all following Taktareas in Train:" />
            </div>
          </template>

          <!-- NOTE not sure if this correct -->
          <template v-else-if="snackbar.action === 'delete'">
            <div class="takt-plan-snack-bar-head">
              <TText text="Apply this change in whole train:" />
            </div>
          </template>
        </template>

        <!-- SNACKBAR BODY -->
        <template #body>
          <!-- BODY CREATE -->
          <template v-if="snackbar.action === 'create'">
            <div class="mt-1 mb-1">
              <!-- CREATE STEP -->
              <SnackBarStepItem v-if="snackbar.target_type.substring(snackbar.target_type.length - 5) === 'steps'"
                :step="snackbar.u_object" :step_type="extractStepType()" :background_color="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.parent_id
                }).color" :foreground_color="getUObject({
  type: 'tworkpackages',
  id: snackbar.parent_id
}).textcolor" />
              <!-- CREATE WORKPACKAGE -->
              <TWorkPackage v-if="snackbar.target_type === 'tworkpackages'" class="ma-2" :workpackage_count="1"
                :zoom="1/*0.7*/" :workpackage="snackbar.u_object" />
            </div>
          </template>

          <!-- BODY UPDATE VALUES -->
          <template v-else-if="snackbar.action === 'update'">
            <!-- UPDATE ELEMENTS -->
            <template v-if="snackbar.bim_process">
              <TText value="Change {key} to {value}"
                :value_props="{ key: Object.keys(snackbar.update)[0], value: snackbar.update[Object.keys(snackbar.update)[0]] }" />
            </template>
            <!-- UPDATE WORKPACKAGES -->
            <template v-else-if="snackbar.target_type === 'tworkpackages'">
              <div class="takt-plan-snack-bar-body-update-value-from-to-container">
                <div class="takt-plan-snack-bar-body-update-value-from-to-item">
                  <FillableCell width="48" height="24" flex_align_horizontal="flex-end" :is_no_shrink="true">
                    <template #content>
                      <TText text="Value:" font_weight="400" />
                    </template>
                  </FillableCell>
                  <TText :text="snackbar.value_name" max_lines="1" />
                </div>
                <div class="takt-plan-snack-bar-body-update-value-from-to-item">
                  <FillableCell width="48" height="24" flex_align_horizontal="flex-end" :is_no_shrink="true">
                    <template #content>
                      <TText text="From:" font_weight="400" />
                    </template>
                  </FillableCell>
                  <TText :text="snackbar.value_old" max_lines="1" />
                </div>
                <div class="takt-plan-snack-bar-body-update-value-from-to-item">
                  <FillableCell width="48" height="24" flex_align_horizontal="flex-end" :is_no_shrink="true">
                    <template #content>
                      <TText text="To:" font_weight="400" />
                    </template>
                  </FillableCell>
                  <TText :text="snackbar.value_new" max_lines="1" />
                </div>
              </div>
            </template>
            <!-- UPDATE WAGGONS TODO: TEST THIS-->
            <template v-else-if="snackbar.target_type === 'twaggons'">
              <TWaggon class="ma-2"
                :workpackage_count="getUObject({ type: 'twaggons', id: snackbar.target_id }).tworkpackages.length"
                :waggon="getUObject({ type: 'twaggons', id: snackbar.target_id })">
                <template #content>
                  <TWorkPackage
                    v-for="workpackage in getUObjects({ type: 'tworkpackages', ids: getUObject({ type: 'twaggons', id: snackbar.target_id }).tworkpackages })"
                    :key="`deletewaggonworkpackage${workpackage.id}`"
                    :workpackage_count="getUObject({ type: 'twaggons', id: snackbar.target_id }).tworkpackages.length"
                    :workpackage="workpackage" />
                </template>
              </TWaggon>
              <div class="takt-plan-snack-bar-body-update-value-from-to-container">
                <div class="takt-plan-snack-bar-body-update-value-from-to-item">
                  <FillableCell width="48" height="24" flex_align_horizontal="flex-end" :is_no_shrink="true">
                    <template #content>
                      <TText text="Value:" font_weight="400" />
                    </template>
                  </FillableCell>
                  <TText :text="snackbar.value_name" max_lines="1" />
                </div>
                <div class="takt-plan-snack-bar-body-update-value-from-to-item">
                  <FillableCell width="48" height="24" flex_align_horizontal="flex-end" :is_no_shrink="true">
                    <template #content>
                      <TText text="From:" font_weight="400" />
                    </template>
                  </FillableCell>
                  <TText :text="snackbar.value_old" max_lines="1" />
                </div>
                <div class="takt-plan-snack-bar-body-update-value-from-to-item">
                  <FillableCell width="48" height="24" flex_align_horizontal="flex-end" :is_no_shrink="true">
                    <template #content>
                      <TText text="To:" font_weight="400" />
                    </template>
                  </FillableCell>
                  <TText :text="snackbar.value_new" max_lines="1" />
                </div>
              </div>
            </template>
            <!-- UPDATE STEPS -->
            <template v-else>
              <div class="mt-1 mb-1">
                <SnackBarStepItem :step="snackbar.update_old_values" :step_type="extractStepType()" :background_color="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.parent_id
                }).color" :foreground_color="getUObject({
  type: 'tworkpackages',
  id: snackbar.parent_id
}).textcolor">
                  <template #above>
                    <TText text="Update step from" />
                  </template>
                  <template #below>
                    <TText text="to" />
                  </template>
                </SnackBarStepItem>
                <SnackBarStepItem :step="snackbar.update" :step_type="extractStepType()" :background_color="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.parent_id
                }).color" :foreground_color="getUObject({
  type: 'tworkpackages',
  id: snackbar.parent_id
}).textcolor" :is_hide_descriptor="true" />
              </div>
            </template>
          </template>

          <!-- BODY UPDATE POSITIONS -->
          <template v-else-if="snackbar.action === 'updateposition'">
            <!-- UPDATE STEP POSITION -->
            <template v-if="snackbar.target_type.substring(snackbar.target_type.length - 5) === 'steps'">
              <div class="mt-1 mb-1">
                <SnackBarStepItem :step="getUObject({
                  type: snackbar.target_type,
                  id: snackbar.target_id
                })" :step_type="extractStepType()" :background_color="getUObject({
  type: 'tworkpackages',
  id: snackbar.parent_id
}).color" :foreground_color="getUObject({
  type: 'tworkpackages',
  id: snackbar.parent_id
}).textcolor">
                  <template #above>
                    <TText :text="getPosUpDownText()" />
                  </template>
                </SnackBarStepItem>
              </div>
            </template>
            <!-- UPDATE WORKPACKAGE OR WAGGON POSITION -->
            <template v-else>
              <TText text="Move" />
              <!-- UPDATE WORKPACKAGE POSITION -->
              <TWorkPackage v-if="snackbar.target_type === 'tworkpackages'" class="ma-2" :workpackage_count="1"
                :zoom="1/*0.7*/" :workpackage="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.target_id
                })" />
              <!-- UPDATE WAGGON POSITION -->
              <TWaggon v-else-if="snackbar.target_type === 'twaggons'" class="ma-2"
                :workpackage_count="getUObject({ type: 'twaggons', id: snackbar.target_id }).tworkpackages.length"
                :waggon="getUObject({ type: 'twaggons', id: snackbar.target_id })">
                <template #content="{ waggon }">
                  <TWorkPackage v-for="workpackage in getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages })"
                    :key="`movewaggonworkpackage${workpackage.id}`" :workpackage_count="waggon.tworkpackages.length"
                    :workpackage="workpackage" />
                </template>
              </TWaggon>
              <TText :text="getPosForwardsBackwardsText(snackbar.position_difference)" />
            </template>
          </template>

          <!-- BODY UPDATE PARENT -->
          <template v-else-if="snackbar.action === 'updateparent'">
            <template>
              <TText text="From" />
              <TWaggon class="ma-2" :workpackage_count="snackbar.parent_cache.tworkpackages.length"
                :waggon="snackbar.parent_cache">
                <template #content="{ waggon }">
                  <TWorkPackage v-for="workpackage in getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages })"
                    :key="`movewaggonworkpackage${workpackage.id}`" :workpackage_count="waggon.tworkpackages.length"
                    :workpackage="workpackage" />
                </template>
              </TWaggon>
              <TText text="to" />
              <TWaggon class="ma-2" :workpackage_count="snackbar.new_parent_cache.tworkpackages.length"
                :waggon="snackbar.new_parent_cache">
                <template #content="{ waggon }">
                  <TWorkPackage v-for="workpackage in getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages })"
                    :key="`movewaggonworkpackage${workpackage.id}`" :workpackage_count="waggon.tworkpackages.length"
                    :workpackage="workpackage" />
                </template>
              </TWaggon>
            </template>
          </template>

          <!-- BODY UPDATE TAKT AREA START -->
          <template v-else-if="snackbar.action === 'updatetaktareastart'">
            <div class="mt-2 mb-2">
              <TText :text="getPosForwardsBackwardsText(snackbar.start_difference, 'Move Taktarea ')" />
            </div>
          </template>

          <!-- BODY DELETE -->
          <template v-else-if="snackbar.action === 'delete'">
            <!-- DELETE STEPS -->
            <template v-if="snackbar.target_type.substring(snackbar.target_type.length - 5) === 'steps'">
              <div class="mt-1 mb-1">
                <SnackBarStepItem :step="snackbar.target_cache" :step_type="extractStepType()" :background_color="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.parent_id
                }).color" :foreground_color="getUObject({
  type: 'tworkpackages',
  id: snackbar.parent_id
}).textcolor">
                  <template #above>
                    <TText text="Delete step:" />
                  </template>
                </SnackBarStepItem>
              </div>
            </template>
            <!-- DELETE WORKPACKAGES OR WAGGONS -->
            <template v-else>
              <TText text="Delete:" />
              <TWorkPackage v-if="snackbar.target_type === 'tworkpackages'" class="ma-2" :workpackage_count="1" :zoom="1"
                :workpackage="snackbar.target_cache" />
              <TWaggon v-else-if="snackbar.target_type === 'twaggons'" class="ma-2"
                :workpackage_count="snackbar.target_cache.tworkpackages.length" :waggon="snackbar.target_cache">
                <template #content="{ waggon }">
                  <TWorkPackage v-for="workpackage in getUObjects({ type: 'tworkpackages', ids: waggon.tworkpackages })"
                    :key="`deletewaggonworkpackage${workpackage.id}`" :workpackage_count="waggon.tworkpackages.length"
                    :workpackage="workpackage" />
                </template>
              </TWaggon>
            </template>
          </template>
        </template>

        <!-- SNACKBAR FOOTER -->
        <template #footer>
          <!-- <TFlex justify_content="space-around" align_items="center" class="mt-1 mb-1"> -->
          <div class="takt-plan-snack-bar-footer">
            <div v-if="snackbar.action === 'update' && snackbar.target_type === 'tworkpackages' && !snackbar.bim_process"
              class="takt-plan-snack-bar-footer-toggle">
              <ToggleCapsule :is_active="snackbar.check_old_value" foreground_color="green lighten-1"
                background_color="primary" border_color="primary" knob_color="primary"
                @toggleClicked="updateSnackbar({ check_old_value: !snackbar.check_old_value })" />
              <TText :text="`Scale only if ${snackbar.value_name} is ${snackbar.value_old}`" />
            </div>

            <div class="takt-plan-snack-bar-footer-buttons">
              <ButtonOutlined text="Close"
                @buttonClicked="updateSnackbar({ show: false, hover: false, affected_additional_targets: false, bim_process: false, response_elements: false, selector: false })" />
              <ButtonOutlined
                v-if="snackbar.target_type === 'tworksteps' && snackbar.affected_additional_targets && snackbar.is_elements"
                :text="`Apply (${snackbar.action === 'create' ? snackbar.affected_parents.length : getAffectedTargets.length})`"
                color="green lighten-1" @buttonClicked="applySnackbarCreateElements()" />
              <ButtonOutlined v-else-if="snackbar.bim_process" :text="`Apply (${snackbar.response_elements.length})`"
                color="green lighten-1" @buttonClicked="applySnackbarUpdateElements()" />
              <ButtonOutlined v-else
                :text="`Apply (${snackbar.action === 'create' ? snackbar.affected_parents.length : getAffectedTargets.length})`"
                color="green lighten-1" @buttonClicked="applySnackbar()" />
            </div>
          </div>
          <!-- </TFlex> -->
        </template>
      </SnackBar>
    </transition>

    <!-- Standard Dialog -->
    <transition name="zoom-translate">
      <router-view name="standard_dialog" />
    </transition>

    <div style="position: fixed; z-index: 100;" v-if="takt_time_filter_popup">
      <PopUpOverlay @closeOverlay="takt_time_filter_popup = false;" width="600px">
        <template #head>
          <TText value="Takt_Time_Filter" font_weight="400" />
        </template>
        <template #body>
          <div class="basic-flex-row" style="justify-content: flex-start;">
            <StandardSwitch :value="$store.state.View.takt_time_filter.active" @changeValue="setTaktTimeFilter(!$store.state.View.takt_time_filter.active, $store.state.View.takt_time_filter.start, $store.state.View.takt_time_filter.end)" ticon="filter" />
            <TText value="Filter_is_active" />
          </div>
          <DisableableInputField input_type="number"
            label="Start Takt" :is_disabled="false" :value="$store.state.View.takt_time_filter.start" background_color="color-2" :is_live_emit="true"
            @change="setTaktTimeFilter($store.state.View.takt_time_filter.active, parseInt($event), $store.state.View.takt_time_filter.end)" />
          <DisableableInputField input_type="number"
            label="End Takt" :is_disabled="false" :value="$store.state.View.takt_time_filter.end" background_color="color-2" :is_live_emit="true"
            @change="setTaktTimeFilter($store.state.View.takt_time_filter.active, $store.state.View.takt_time_filter.start, parseInt($event))" />
        </template>
      </PopUpOverlay>
    </div>

    <!-- InfoBox-->
    <!-- <transition
      name="zoom-translate"
      >
      <router-view v-if="isEditMode" name="info_box"></router-view>
    </transition> -->

    <!-- SideBar -->
    <transition name="slide">
      <!-- <router-view v-if="isEditMode || ($route.matched[2] && $route.matched[2].name === 'MilestonesSideBar')" name="side_bar"></router-view> -->
      <router-view name="side_bar"></router-view>
    </transition>
    <!-- Taktplan -->
    <v-container fluid class="pa-0" style="position: absolute" id="taktplan-container">
      <!-- && $store.state.View.is_printing_mode -->
      <div id="legend-container"
        v-if="legend_left != 0 && $store.state.View.is_taktplan_legend && !$store.state.View.is_taktplan_legend_left"
        class="takt-plan-workpackage-legend" :style="`
          left: ${legend_left}px;
        `">
        <TText value="Legend" size="20" font_weight="400" />

        <div 
          id="legend-container-milestone-left" class="takt-plan-workpackage-legend-train"
          v-if="$store.state.View.is_taktplan_legend_milestones"
        >
          <div class="takt-plan-workpackage-legend-train" :style="` min-width: ${legend_width}px; max-width: ${legend_width}px;`">
            <TText value="Milestones" />
            <div class="takt-plan-workpackage-legend-train-line" :style="`background-color: ${$vuetify.theme.dark ? 'white' : 'black'};`" />
            <div v-for="m in getPMileStones(project_id)" :key="`pmilestone-${m.pmilestone.id}`" class="takt-plan-workpackage-legend-train-item mt-2 mb-1" style="grid-gap: 8px;" >
              <MileStoneStyle 
                :milestone="m.pmilestone" type="project"/>
              <TText :value="m.pmilestone.name" max_lines="2" />
            </div>
            <div v-for="m in getMileStones(project_id)" :key="`milestone-${m.milestone.id}`" class="takt-plan-workpackage-legend-train-item mt-2 mb-1" style="grid-gap: 8px;" >
              <MileStoneStyle 
                :milestone="m.milestone" type="train"/>
              <TText :value="m.milestone.name" max_lines="2" />
            </div>
          </div>
        </div>


        <div v-for="train, index in trains" :key="`legend-train${index}`" class="takt-plan-workpackage-legend-train"
          :style="`
            min-width: ${legend_width}px;
                      max-width: ${legend_width}px;
          `">
          <TText :text="train.name" />
          <div class="takt-plan-workpackage-legend-train-line"
            :style="`background-color: ${$vuetify.theme.dark ? 'white' : 'black'};`" />
          <div v-for="wp in getUniqueTWorkPackagesByTrain(train)"
            :key="`wp-${wp.token}-${wp.icon}-${wp.color}-${wp.name}`" class="takt-plan-workpackage-legend-train-item">
            <TWorkPackage class="ml-2 mr-2" :workpackage_count="1" :zoom="$store.state.View.taktplan_zoom" :color="calcLegendWPColor(wp, train)"
              :workpackage="wp" style="flex-shrink: 0;" />
            <TText :text="wp.name" max_lines="2" />
          </div>
        </div>
      </div>
      <div v-if="$store.state.View.is_printing_mode" :style="`display: flex; flex-direction: row; justify-content: space-between; width: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + ${getProjectLength(project_id) + 2} * ((var(--workpackage_width) + 8px) * var(--taktplan_zoom))`">
        <h1  class="ml-2">{{ project.name }}</h1>
        <h1  v-if="$store.state.View.is_taktplan_timestamp" class="mr-2">{{ getCurrentTimesptampString() }}</h1>
      </div>
      
      <!-- FlexBar -->
      <FlexBar v-if="$store.state.View.show_taktplan & !isProjectEmpty" :project_length="isSpatialView ? getProjectLength(project_id) : getProjectLength(project_id) + 1"
        header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
        :set_statistics_height="getStatisticsHeightVariables.set_statistics_height">
        <template #statistics-activator>
          <Activator v-if="location !== 'HistProject'" class="self-centered cursor-row-resize"
            :key="`statistics_activator`" @mousedown.native="flexBarHeightMouseDown({
              evt: $event,
            })" @touchstart.native="flexBarHeightMouseDown({
  evt: $event,
})" />
        </template>

        <!-- Statistics -->
        <template #statistics>
          <!-- Takt time Highlighter statistics-->
          <v-progress-circular v-if="$store.state.ProjectStatistics.statistics_loading" indeterminate
            style="position: absolute; left: 50%; top: 10%; z-index: 120" />
          <TaktTimeHighLighter v-if="getCurrentTaktIndex(project_id) !== false &&
            $store.state.View.is_taktplan_takttime_highlight"
            :index="isSpatialView ? Math.abs(getCurrentTaktIndex(project_id)) : Math.abs(getCurrentTaktIndex(project_id)) + 1"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px" />
          <TaktTimeHighLighter v-if="getCurrentTaktIndex(project_id) !== false &&
            getCurrentTaktIndex(project_id) >= 0 &&
            $store.state.View.is_taktplan_takttime_highlight"
            :index="isSpatialView ? getCurrentTaktIndex(project_id) + 1 : getCurrentTaktIndex(project_id) + 2"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px" />
          <!-- MILESTONE HIGHLIGHT -->
          <template
            v-if="$store.state.View.is_taktplan_milestone_highlight && getUObject({ type: 'projects', id: project_id }).showMilestones">
            <TaktTimeHighLighter v-for="milestone, i in getMileStones(project_id)"
              :key="`takt-plan-milestone-highlight-${i}`" :index="milestone.takt_index.index + 1"
              header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
              border_style="dashed" />
            <TaktTimeHighLighter v-for="pmilestone, i in getPMileStones(project_id)"
              :key="`takt-plan-pmilestone-highlight-${i}`" :index="pmilestone.takt_index.index + 1"
              header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
              border_style="dashed" />
          </template>
          <!-- /MILESTONE HIGHLIGHT -->
          <HeaderRowStatistics ref="header_row_statistics"
            :set_statistics_height="getStatisticsHeightVariables.set_statistics_height" :isSpatialView="isSpatialView">
            <template #basic-info>
              <v-img max-height="80%" class="ma-2" contain
                gradient="to top,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.05),rgba(0, 0, 0, 0.4)" :src="project.image">
                <v-btn icon @click="$refs.project_image.click()" v-if="isEditMode">
                  <input v-show="false" ref="project_image" type="file" @change="addProjectImage()" capture="camera" />
                  <v-icon>add_a_photo</v-icon>
                </v-btn>
              </v-img>
            </template>
            <template #statistic-settings v-if="!isCloudPrint">
              <TIconButton icon="cycle" tooltip="Reload_Flexbar" @clickIcon="requestUObject({
                    url: [
                      { projects: parseInt(project_id) },
                      { flexbar: '' }
                    ],
                    no_cache: true
                  })" />
              <StandardOverflowButton element_id="standard_overflow_button_1" tooltip="Statistics" ref="statisticSettings" :click_to_open="true"
                ticon="takt-plan-workpackage" :value="{
                  value: getStatisticSettings.value
                }" :options="{
  value: [
    { value: 'workpackages', ticon: 'takt-plan-workpackage', icon: 'dns', disabled: false, tooltip: 'Number of WORK.packages' },
    { value: 'calendar', ticon: 'calendar', icon: 'calendar_today', disabled: false, tooltip: 'Calendar' },
  ],
  value2: [
    { value: 'time_effort_planned', ticon: 'speedometer', icon: 'speed', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Planned time effort') },
    { value: 'manpower_planned', ticon: 'person-standing', icon: 'accessibility', disabled: false, tooltip: 'Planned manpower' },
    { value: 'duration_planned', ticon: 'stopwatch', icon: 'timer', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Duration planned') },
    { value: 'time_effort_actual', ticon: 'speedometer', icon: 'speed', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Actual time effort') },
    { value: 'manpower_actual', ticon: 'person-standing', icon: 'accessibility', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Actual manpower') },
    { value: 'duration_actual', ticon: 'stopwatch', icon: 'timer', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Actual duration') },
    { value: 'image_count', ticon: 'image', icon: 'photo', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of images') },
    { value: 'log_entry_count', ticon: 'clipboard-pencil', icon: 'book', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of LOG.entries') },
    { value: 'autopilotissue_count', ticon: 'steering-wheel', icon: 'bug_report', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of AUTOPILOT.issues') },
    { value: 'costs_budget_total', ticon: 'wallet', icon: 'account_balance_wallet', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Total Budget') },    
    { value: 'costs_tendered_total', ticon: 'shopping-cart', icon: 'shopping_cart', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Total Tendered Costs') },
    { value: 'costs_paid_out_total', ticon: 'money', icon: 'money', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Total Paid out Costs') },
    { value: 'costs_budget_labour', ticon: 'wallet', icon: 'account_balance_wallet', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Budget Labour') },
    { value: 'costs_tendered_labour', ticon: 'shopping-cart', icon: 'shopping_cart', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Tendered Labour Costs') },
    { value: 'costs_paid_out_labour', ticon: 'money', icon: 'payments', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Paid out Labour Costs') },
    { value: 'costs_budget_material', ticon: 'wallet', icon: 'account_balance_wallet', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Budget Material') },
    { value: 'costs_tendered_material', ticon: 'shopping-cart', icon: 'shopping_cart', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Tendered Material Costs') },
    { value: 'costs_paid_out_material', ticon: 'money', icon: 'payments', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Paid out Material Costs') },
    { value: 'carbon_dioxide', ticon: 'co2', icon: 'payments', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Carbon Dioxide from Materials') },
  ],
  value3: [
    { value: 'tlogistic_step_count', ticon: $store.state.Ultra.step_icons['logistic'], icon: 'mdi-truck-cargo-container', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of LOGISTIC.steps') },
    { value: 'tdesign_step_count', ticon: $store.state.Ultra.step_icons['design'], icon: 'mdi-pencil-ruler', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of DESIGN.steps') },
    { value: 'twork_step_count', ticon: $store.state.Ultra.step_icons['work'], icon: 'mdi-account-hard-hat', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of WORK.steps') },
    { value: 'tquality_step_count', ticon: $store.state.Ultra.step_icons['quality'], icon: 'mdi-comment-check-outline', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of QUALITY.steps') },
    { value: 'tdefect_step_count', ticon: $store.state.Ultra.step_icons['defect'], icon: 'mdi-glass-fragile', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of DEFECT.steps') },
    { value: 'thandover_step_count', ticon: $store.state.Ultra.step_icons['handover'], icon: 'mdi-handshake', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of HANDOVER.steps') },
    { value: 'tmaterial_step_count', ticon: $store.state.Ultra.step_icons['material'], icon: 'mdi-wall', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of MATERIAL.steps') },
    { value: 'tmachine_step_count', ticon: $store.state.Ultra.step_icons['machine'], icon: 'mdi-crane', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Number of MACHINE.steps') },
  ]
}" @button-clicked="setShowMilestones(false)" @select-option="setStatisticSettings({ setting: $event.setting, value: $event.value, project_id: project_id }),
  setShowMilestones(false)" />


              <StandardOverflowButton element_id="standard_overflow_button_2" v-if="getStatisticSettings.value === 'workpackages'" tooltip="PEP"
                ref="statisticSettingsPep" :click_to_open="true" ticon="check-large" :value="{
                  value: getStatisticSettings.pep_value
                }" :options="{
  value: [
    { name: 'none', value: 'none', color: '', icon: 'checkbox-radial-empty', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('None and up') },
    { name: 'ready', value: 'ready', color: 'grey lighten-2', icon: 'checked-stopwatch', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Ready and up'), status_index: 1 },
    { name: 'started', value: 'started', color: 'grey lighten-1', icon: 'plane-takeoff', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Started and up'), status_index: 2 },
    { name: 'done', value: 'done', color: 'grey darken-1', icon: 'check-large', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Done and up'), status_index: 3 },
    { name: 'checked', value: 'checked', color: 'grey darken-2', icon: 'thumbs-up', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Checked and up'), status_index: 4 },
    { name: 'closed', value: 'closed', color: 'grey darken-3', icon: 'close', disabled: !hasPermission('Flexbar READ'), tooltip: getFlexbarToolTip('Closed'), status_index: 5 },
  ]
}" @button-clicked="setShowMilestones(false)" @select-option="setStatisticSettings({ setting: 'pep_value', value: $event.value, project_id: project_id }),
  setShowMilestones(false)" />



              <v-divider class="mt-1 mb-1" width="90%" color="grey" />
              <StandardOverflowButton element_id="standard_overflow_button_3" tooltip="Statistic Settings" ref="statisticSettingsCumulative" :click_to_open="true"
                ticon="poll" :value="{ cumulative: getStatisticSettings.cumulative }" :options="[
                  'manpower_planned',
                  'manpower_actual',
                  // 'time_effort_planned',
                  'time_effort_actual',
                  'calendar',
                ].includes(getStatisticSettings.value) ?
                  {
                    cumulative: [
                      { value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Per TAKT.time' },
                    ]
                  }
                  :
                  {
                    cumulative: [
                      { value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Per TAKT.time' },
                      { value: true, ticon: 'ascending', icon: 'signal_cellular_alt', tooltip: 'Cumulative' }
                    ]
                  }
                  " @button-clicked="setShowMilestones(false)" @select-option="setStatisticSettings({ setting: $event.setting, value: $event.value, project_id: project_id }),
    setShowMilestones(false)" />
              <v-divider class="mt-1 mb-1" width="90%" color="grey" />
              <StandardOverflowButton element_id="standard_overflow_button_4" tooltip="Set Filter" ref="filter" :click_to_open="true" ticon="filter"
                icon="filter_alt" :multiselect="true" :button_color="getStatisticSettings.filter ? 'color-3' : ''" :value="{
                  icons: getStatisticSettings.icons,
                  colors: getStatisticSettings.colors,
                  status: getStatisticSettings.status,
                  trains: getStatisticSettings.trains,
                  milestones: getStatisticSettings.milestones
                }" :options="{
  icons: getTWorkpackageIcons,
  colors: getTWorkpackageColors,
  status: getFullStatusArray,
  trains: getStatisticsTrainSelector(project_id),
  milestones: getStatisticsMilestoneSelector(project_id),
}" @button-clicked="setShowMilestones(false)"
                @button-clicked-strg="resetFilter(), setStatisticSettings({ setting: $event.setting, value: $event.value, project_id: project_id }), setShowMilestones(false)"
                @select-option="setStatisticSettings({ setting: $event.setting, value: $event.value, project_id: project_id }),
                  setShowMilestones(false)" />

              <TIconButton :is_clicked="!getStatisticSettings.filter" icon="visibility-off"
                tooltip="Set_Filter_Visibility"
                @clickIcon="setStatisticSettings({ setting: 'filter', project_id: project_id }), setShowMilestones(false)" />

              <TIconButton icon="restart" tooltip="Reset_Filter" @clickIcon="resetStatisticSettings()" />

              <v-divider class="mt-1 mb-1" width="90%" color="grey" />

              <TIconButton :is_clicked="isShowMilestones" icon="rhombus" tooltip="Milestones"
                @clickIcon="setShowMilestones(!isShowMilestones)" />
            </template>
          </HeaderRowStatistics>
          <StatisticsBackgroundBlurr ref="statistics_background_blurr" id="statistics_background_blurr"
            :project_length="getProjectLength(project_id)"
            :set_statistics_height="getStatisticsHeightVariables.set_statistics_height"
            :statistics="isStatisticsVisible?getStatistics(project_id):{}" :current_takt_index="getCurrentTaktIndex(project_id)"
            :current_day_index="getCurrentDayIndex(project_id)">
            <template #default="statistics_slot" v-if="isStatisticsVisible">
              <template v-if="isShowMilestones">
                <StandardFlexBox class="pt-2" direction="column" width="100%" height="100%" :no_wrap="true">
                  <MileStonesLane class="cursor-pointer" name="Project" :hasLine="true"
                    @click.native="$router.push({ name: 'ProjectMilestones' })">
                    <MileStone v-for="pmilestone in getPMileStones(project_id)" :key="pmilestone.pmilestone.id"
                      :token="pmilestone.pmilestone.token"
                      :status="getProjectMilestoneStatus({ id: pmilestone.pmilestone.id, takt_index: pmilestone.takt_index, project_id })"
                      type="project" :takt_index="pmilestone.takt_index" :offset_y="pmilestone.offset_y"
                      :distance_min="pmilestone.distance_min"
                      @click.native.prevent.stop="$router.push({ name: 'ProjectMilestonesDetails', params: { pmilestone_id: pmilestone.pmilestone.id } })" />
                    <MileStone v-if="getNewPMilestone(project_id).date !== ''" type="new-project"
                      :takt_index="getNewPMilestone(project_id).takt_index"
                      :token="getNewPMilestone(project_id).pmilestone.token" :large="true" />
                  </MileStonesLane>
                  <MileStonesLane class="cursor-pointer"
                    v-for="train in getUObjects({ type: 'trains', ids: project.trains })" :key="train.id"
                    :name="train.name" :hasLine="true" @click.native="$router.push({ name: 'TrainMilestones' })">
                    <template v-for="milestone in getMileStones(project_id)">
                      <MileStone v-if="milestone.trains.includes(train.id)" :key="milestone.milestone.id"
                        :token="milestone.milestone.token"
                        :status="getTrainMilestoneStatus({ milestone_id: milestone.milestone.id, project_id })"
                        type="train" :takt_index="milestone.takt_index" :offset_y="milestone.offset_y"
                        :distance_min="milestone.distance_min"
                        @click.native.prevent.stop="$router.push({ name: 'TrainMilestonesDetails', params: { milestone_id: milestone.milestone.id } })" />
                    </template>
                    <MileStone v-if="getNewMilestone(project_id).trains.includes(train.id)" type="new-train"
                      :takt_index="getNewMilestone(project_id).takt_index"
                      :token="getNewMilestone(project_id).milestone.token" :large="true" />
                  </MileStonesLane>
                </StandardFlexBox>
              </template>
              <template v-else>
                <template v-for="(takt_values, takt_values_index) in statistics_slot.statistics.takt_values">
                  <StatisticsTakt  v-if="!$store.state.View.takt_time_filter.active || (takt_values_index > $store.state.View.takt_time_filter.start && takt_values_index < $store.state.View.takt_time_filter.end)"
                    :key="`statistics_takt_${takt_values_index}`">
                    <template v-if="getStatisticSettings.value === 'calendar'">
                      <StatisticsCard v-for="(takt_value, takt_value_index) in takt_values.values"
                        :key="`statistics_takt_value_${takt_value_index}`" :value="takt_value.value"
                        :background_color="takt_values_index === statistics_slot.current_takt_index && takt_value_index === statistics_slot.current_day_index ? 'var(--v-primary-base)' : ''" />
                    </template>
                    <template v-else>
                      <StatisticsBeamTaktSum v-if="takt_values.takt_sum !== 0">
                        {{ displayNumber(takt_values.takt_sum) }}
                      </StatisticsBeamTaktSum>
                      <StatisticsBeam v-for="(takt_value, takt_value_index) in takt_values.values"
                        :key="`statistics_takt_value_${takt_value_index}`" :value="takt_value.value"
                        :max_value="statistics_slot.statistics.max_takt_sum" :color="takt_value.color"
                        :icon="takt_value.icon" :tooltip="takt_value.tooltip" />
                    </template>
                  </StatisticsTakt>
                </template>
              </template>
            </template>
          </StatisticsBackgroundBlurr>
        </template>
        <!-- Header Columns Months -->
        <template #header-columns-months>
          <HeaderPlaceholder width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            height="26px" z_index="5" sticky_left="0px">

            <v-menu offset-y v-if="getMultiProjectsByProject(project_id).length">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text x-small dark v-bind="attrs" v-on="on">
                  <TText value="MULTI.Projects" />
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in getMultiProjectsByProject(project_id)" :key="`multiprojectlink${index}`" link @click="$router.push({name: 'MultiProjectSchedule', params: {multiproject_id: item.id}})">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <template #right-middle>
              <ActivatorSlider class="self-centered cursor-col-resize"
                css_variable="--project_taktplan_spatial_header_width" />
            </template>
          </HeaderPlaceholder>
          <HeaderPlaceholder width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="26px" z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))">
            <template #right-middle>
              <ActivatorSlider class="self-centered cursor-col-resize"
                css_variable="--project_taktplan_ta_header_width" />
            </template>
          </HeaderPlaceholder>
          <HeaderPlaceholder :key="isSpatialView" v-if="!isSpatialView"
            width="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))" height="26px" z_index="3" />
            <!-- TODO: calc correct minus value -->
            <template v-for="month in getCalendar(project_id).months">
              <HeaderColumnMonth v-if="!$store.state.View.takt_time_filter.active || ((month.takt_index > $store.state.View.takt_time_filter.start || month.takt_index + month.duration > $store.state.View.takt_time_filter.start) && (month.takt_index < $store.state.View.takt_time_filter.end))" z_index="3" :key="month.name"
                :duration="$store.state.View.takt_time_filter.active ? getTaktTimeFilterMonthDuration(getCalendar(project_id).months, month) : month.duration">
                <!-- {{ month.name }} -->
                <TText :value="`${$store.state.Ultra.months[month.integer]} {year}`"
                  :value_props="{ year: ` '${month.year.toString().substring(2, 4)}` }" />
              </HeaderColumnMonth>
            </template>
          <HeaderColumnMonth v-if="getCalendar(project_id).months.length === 0" z_index="3"
            :duration="getProjectLength(project_id)" />
          <HeaderColumnMonth z_index="3" />
        </template>
        <!-- width: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + ${getProjectLength(project_id) + 1} * ((var(--workpackage_width) + 8px) * var(--taktplan_zoom)); -->
        <template v-if="getUObject({ type: 'projects', id: project_id }).showMilestones" #project-milestones>
          <div class="color-1" 
          :style="`
          width: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + ${getProjectLength(project_id) + 1} * ((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
          display: flex;
          flex-direction: row;
          `">
            <HeaderRow style="flex-shrink: 0" :z_index="6"
              width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom)) "
              sticky_left="0px" color="color-1" :readonly="true" />
            <div style="width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom)); flex-shrink: 0" />
            <MileStonesLane
              style="min-height: 0px; height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
              class="cursor-pointer" justify_content="center" @click.native="$router.push({ name: 'ProjectMilestones' })">
              <MileStone v-for="pmilestone in getPMileStones(project_id)" :key="pmilestone.pmilestone.id"
                :token="pmilestone.pmilestone.token"
                :status="getProjectMilestoneStatus({ id: pmilestone.pmilestone.id, takt_index: pmilestone.takt_index, project_id })"
                :zoom="$store.state.View.taktplan_zoom" type="project" :takt_index="pmilestone.takt_index"
                :offset_y="pmilestone.offset_y" :distance_min="pmilestone.distance_min" :z_index="1"
                @click.native.prevent.stop="$router.push({ name: 'ProjectMilestonesDetails', params: { pmilestone_id: pmilestone.pmilestone.id } })" />
              <MileStone v-if="getNewPMilestone(project_id).date !== '' && $route.name === 'ProjectMilestonesAdd'"
                type="new-project" :takt_index="getNewPMilestone(project_id).takt_index"
                :token="getNewPMilestone(project_id).pmilestone.token" :large="true" :z_index="1" />
            </MileStonesLane>
          </div>
        </template>
        <!-- Header Columns -->
        <template #header-columns>
          <HeaderPlaceholder width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))" max_height="75px" z_index="4"
            sticky_left="0px">
            <v-progress-circular v-if="structure_loading && Object.keys($store.state.Ultra.sites).length === 0" :size="18"
              :width="3" indeterminate color="grey lighten-5"></v-progress-circular>
            <StandardSwitch v-if="location !== 'HistProject'" :value="isSpatialView" @changeValue="
              Object.keys($store.state.Ultra.sites).length === 0 ?
                (
                  structure_loading = true,
                  requestUObject({
                    url: [
                      { projects: parseInt(project_id) },
                      { projectstructure: '' }
                    ],
                  }).then(() => {
                    requestUObject({
                      url: [
                        { projects: parseInt(project_id) },
                        { taktareaselements: '' }
                      ],
                    }).then(() => {
                      requestProjectElements(project_id).then(() => {
                        $route.name !== 'ProjectTaktPlan' ? routeToTaktplan() : '',
                          setSpatialView(!isSpatialView)
                      })
                    })
                  })
                )
                :
                (
                  $route.name !== 'ProjectTaktPlan' ? routeToTaktplan() : '',
                  setSpatialView(!isSpatialView)
                )" ticon="house-chimney" />
            <StandardSwitch v-if="location !== 'HistProject' && project.calendar_project_start"
              :value="getUObject({ type: 'projects', id: project_id }).showMilestones"
              @changeValue="toggleTaktplanMilestonesView({ project_id: project_id })" ticon="rhombus-full" />
            <v-btn icon small :color="$route.name === 'TaktPlanBacklogs' ? 'black' : ''"
              :class="$route.name === 'TaktPlanBacklogs' ? 'white' : ''"
              @click="setNewWPPosition(false);$router.push({ name: $route.name === 'TaktPlanBacklogs' ? 'ProjectTaktPlan' : 'TaktPlanBacklogs' })">
              BL
            </v-btn>
            <!-- EXPAND ALL TRAINS TOGGLE -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <button v-bind="attrs" v-on="on"
                  @click="location === 'HistProject' ? toggleAllHistTrains() : toggleAllTrains()">
                  <TIcon name="chevron-right" color="primary" large
                    :style="is_collapsed ? '' : 'transform: rotate(90deg)'" />
                </button>
              </template>
              <span>{{ is_collapsed ? 'Expand all' : 'Collapse all' }}</span>
            </v-tooltip>
            <!-- /EXPAND ALL TRAINS TOGGLE -->
          </HeaderPlaceholder>
          <!-- v-if="isSpatialView" -->

          <!-- EXPAND ALL TRAINS TOGGLE -->
          <HeaderPlaceholder width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))" max_height="75px" z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            style="overflow: hidden">

            <TTooltip value="For additive filter use ';' to separate filter terms" top>
              <DisableableInputField :icon="$store.state.View.taktarea_filter ? 'filter-inverted' : 'filter'"
                label="Filter Taktareas" :is_disabled="false" :value="$store.state.View.taktarea_filter"
                background_color="color-2" :is_live_emit="true"
                style="width: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) - 40px);"
                @change="setValue({ key: 'taktarea_filter', value: $event })" />
            </TTooltip>

            <!-- /FILTER TAKTAREAS -->
          </HeaderPlaceholder>

          <HeaderColumn v-if="!isSpatialView" z_index="3">
            <v-btn
              v-if="isEditMode && hasProjectPermission({ 'project_id': project_id, ppermission: 'Update Project information' })"
              @click="$router.push({
                name: 'EditCalendar'
              })" :class="is_show_side_bar ? 'grey darken-2' : ''" icon>
              <v-icon>
                calendar_today
              </v-icon>
            </v-btn>
            <TIcon
              v-if="!isEditMode"
              @click.native="takt_time_filter_popup=true" :class="is_show_side_bar ? 'grey darken-2' : ''" name="filter" class="cursor-pointer">
            </TIcon>
          </HeaderColumn>

          <template v-if="getCalendar(project_id).takt_times.length !== 0">
            <template v-for="(takt_time, index) in getCalendar(project_id).takt_times">
              <HeaderColumn :key="`takttime${index}`" v-if="!$store.state.View.takt_time_filter.active || (index > $store.state.View.takt_time_filter.start && index < $store.state.View.takt_time_filter.end)" z_index="3">
                <DateCircle @click.native="shiftDateCircleValue()"
                  :value="getDateCircleValue(takt_time, index)" />
              </HeaderColumn>
            </template>
            
          </template>
          <template v-else>
            <HeaderColumn v-for="(takt_time, index) in getProjectLength(project_id)" :key="`takttime${index}`"
              z_index="3" />
          </template>
          <HeaderColumn z_index="3">
          </HeaderColumn>
        </template>
      </FlexBar>
      <!-- <v-btn v-if="location !== 'HistProject' && project.trainsbacklogs.length === 0 && $route.name !== 'AddTrain'"
        @click="$router.push({
          name: 'AddTrain',
          params: {
            project_id: project_id,
            train_index: 0,
            direction: 0,
          }
        })">
        Add Train or Backlog
      </v-btn> -->
      <div 
        v-if="location !== 'HistProject' && project.trainsbacklogs.length === 0"
        style="position: absolute; left: 50%; top: 200px; transform: translateX(-50%)"
        >
        <TText value="Start your Project"/>
        <div class="d-flex">
          <!-- EMPTY TRAIN -->
          <div>
            <ButtonOutlined 
              text="Add Empty Train"
              icon="sign-plus"
              width="200"
              @buttonClicked="add_empty_train = !add_empty_train"
            />
            <div 
              v-if="add_empty_train"
              class="d-flex mt-2"
              >
              <DisableableInputField 
                  label="Waggon Count" 
                  width="142px"
                  :is_disabled="false" 
                  :value="empty_train_waggon_count"
                  background_color="color-2" 
                  @change="empty_train_waggon_count = parseInt($event)" 
                  />
                  <ButtonOutlined 
                    class="ml-2"
                    text="Add"
                    width="50"
                    height="42"
                    style="height: 42px; margin-top: 5px"
                    @buttonClicked="createUObject({
                    url: [
                      {projects: project_id},
                      {trains: 'completetrain'},
                      {showWithEntitiesNormalized: ''}
                    ],
                    u_object: getEmptyTrainPayload(),
                    trainsbacklogs: true,
              })"
                  />
            </div>
          </div>
          <!-- SEQUENCES -->
          <ButtonOutlined 
            text="Add Train from Workbench"
            icon="sign-plus"
            width="240"
            height="50"
            style="height: 50px"
            class="mr-3 ml-3"
            @buttonClicked="$router.push({
              name: 'AddTrain',
              params: {
                project_id: project_id,
                train_index: 0,
                direction: 0,
              }
            })" 
          />
          <!-- BACKLOGS -->
          <ButtonOutlined
                v-if="project.trains.length !== 0"
                value="Add Backlog Group"
                icon="sign-plus"
                width="200"
                height="50"
                style="height: 50px"
                @buttonClicked="createUObject({
                  url: [
                    {projects: project_id},
                    {wbgroups: ''},
                    {showWithEntitiesNormalized: ''}
                  ],
                    u_object: {
                      name: 'New Group',
                      description: 'description',
                      position: 1,
                    },
                    trainsbacklogs: true,
                  }).then(group_id => {
                    createUObject({
                      url: [
                        {projects: project_id},
                        {wbgroups: group_id},
                        {wblines: ''},
                        {showWithEntitiesNormalized: ''}
                      ],
                        u_object: {
                          name: 'New Line',
                          description: 'description',
                          position: 1
                        }
                      })
                    })"
              />
        </div>
      </div>
      <template v-else-if="!isSpatialView">
        <template v-if="$store.state.View.show_taktplan">
          <draggable :key="`trains${project_id}`" animation="300" forceFallback="true" fallbackOnBody="true"
            :disabled="draggable_disabled || !isEditMode || $route.name !== 'ProjectTaktPlan' || !hasProjectPermission({ 'project_id': project_id, ppermission: 'Update Trains' }) ? true : false"
            :value="project.trainsbacklogs" handle=".trainhead, .traintail, .swap-arrow-wbgroup" @update="($event.newIndex - $event.oldIndex !== 0) ? updateUObjectPosition({
              url:
                project.trainsbacklogs[$event.oldIndex].type === 'wbgroups' ?
                  [
                    { projects: project_id },
                    { wbgroups: project.trainsbacklogs[$event.oldIndex].id },
                  ]
                  :
                  [
                    { projects: project_id },
                    { trains: project.trainsbacklogs[$event.oldIndex].id },
                  ],
              update: {
                position: $event.newIndex - $event.oldIndex
              },
              trainsbacklogs: true,
              old_index: $event.oldIndex,
              new_index: $event.newIndex,
            }) : ''"
            @start="dragging_train_id = `${project.trainsbacklogs[$event.oldIndex].type}${project.trainsbacklogs[$event.oldIndex].id}`"
            @end="dragging_train_id = -1">
            <TPTrain v-for="(train, train_index) in trains" :key="`train${train.id}`"
              :draggable_disabled="draggable_disabled" :project_id="project_id" :train="train" :train_index="train_index" :train_count="trains.length"
              :new_milestone="new_milestone" :milestone_selection="milestone_selection" :snackbar="snackbar"
              :location="location" :dragging_train="dragging_train_id === `${train.type}${train.id}`"
              :backlog="train.type === 'wbgroups' || train.type === 'histwbgroups'" class="takt-plan-train-container"
              :current_takt_index="getCurrentTaktIndex(project_id)"
              @toggleDraggable="draggable_disabled = $event" />
          </draggable>
          <div
            v-if="!$store.state.View.is_printing_mode && !($store.state.View.is_taktplan_legend && $store.state.View.is_taktplan_legend_left)"
            @click="routeToTaktplan()"
            class="big_black_block" 
            />
        </template>

        <!-- @click.self="routeToTaktplan()" -->

        <!-- Work Package Legend Left -->
        <div id="legend-container"
          v-if="$store.state.View.is_taktplan_legend && $store.state.View.is_taktplan_legend_left && !$store.state.View.is_taktplan_legend_left_rotated"
          class="takt-plan-workpackage-legend" style="position: relative !important;">
          <TText value="Legend" size="20" font_weight="400" />
          <div class="basic-flex-row" style="justify-content: flex-start;align-items: flex-start; grid-gap: 4px;">
            <div 
              id="legend-container-milestone-left" class="takt-plan-workpackage-legend-left"
              v-if="$store.state.View.is_taktplan_legend && $store.state.View.is_taktplan_legend_milestones && $store.state.View.is_taktplan_legend_left && !$store.state.View.is_taktplan_legend_left_rotated"
            >
              <div class="takt-plan-workpackage-legend-train" :style="` min-width: ${legend_width}px; max-width: ${legend_width}px;`">
                <TText value="Milestones" />
                <div class="takt-plan-workpackage-legend-train-line" :style="`background-color: ${$vuetify.theme.dark ? 'white' : 'black'};`" />
                <div v-for="m in getPMileStones(project_id)" :key="`pmilestone-${m.pmilestone.id}`" class="takt-plan-workpackage-legend-train-item mt-2 mb-1" style="grid-gap: 8px;" >
                  <MileStoneStyle 
                    :milestone="m.pmilestone" type="project"/>
                  <TText :value="m.pmilestone.name" max_lines="2" />
                </div>
                <div v-for="m in getMileStones(project_id)" :key="`milestone-${m.milestone.id}`" class="takt-plan-workpackage-legend-train-item mt-2 mb-1" style="grid-gap: 8px;" >
                  <MileStoneStyle 
                    :milestone="m.milestone" type="train"/>
                  <TText :value="m.milestone.name" max_lines="2" />
                </div>
              </div>
            </div>
            <div id="legend-container-left" class="takt-plan-workpackage-legend-left">
              <div v-for="train, index in trains" :key="`legend-train${index}`" class="takt-plan-workpackage-legend-train"
                :style="`min-width: ${legend_width}px;max-width: ${legend_width}px;`">
                <TText :text="train.name" />
                <div class="takt-plan-workpackage-legend-train-line"
                  :style="`background-color: ${$vuetify.theme.dark ? 'white' : 'black'};`" />
                <div v-for="wp in getUniqueTWorkPackagesByTrain(train)"
                  :key="`wp-${wp.token}-${wp.icon}-${wp.color}-${wp.name}`" class="takt-plan-workpackage-legend-train-item">
                  <TWorkPackage class="ml-2 mr-2" :workpackage_count="1" :zoom="$store.state.View.taktplan_zoom" :color="calcLegendWPColor(wp, train)"
                    :workpackage="wp" style="flex-shrink: 0;" />
                  <TText :text="wp.name" max_lines="2" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Work Package Legend Left rotated -->
        <div id="legend-container"
          v-if="$store.state.View.is_taktplan_legend && $store.state.View.is_taktplan_legend_left && $store.state.View.is_taktplan_legend_left_rotated"
          class="takt-plan-workpackage-legend-left-rotated" :style="`width: ${legend_left}px`"
          style="position: relative !important;">
          <TText value="Legend" size="20" font_weight="400" />

          <!-- <div class="basic-flex-col"> -->
            <div 
              id="legend-container-milestone-left" class="takt-plan-workpackage-legend-left-rotated" :style="`width: ${legend_left}px`"
              v-if="$store.state.View.is_taktplan_legend && $store.state.View.is_taktplan_legend_milestones && $store.state.View.is_taktplan_legend_left && $store.state.View.is_taktplan_legend_left_rotated"
            >
              <div class="takt-plan-workpackage-legend-train-left-rotated">
                <TText value="Milestones" />
                <div class="takt-plan-workpackage-legend-train-line" :style="`background-color: ${$vuetify.theme.dark ? 'white' : 'black'};`" />
                <div v-for="m in getPMileStones(project_id)" :key="`pmilestone-${m.pmilestone.id}`" class="takt-plan-workpackage-legend-train-item-left-rotated" style="grid-gap: 8px;" >
                  <MileStoneStyle 
                    :milestone="m.pmilestone" type="project"/>
                  <TText :value="m.pmilestone.name" max_lines="2" />
                </div>
                <div v-for="m in getMileStones(project_id)" :key="`milestone-${m.milestone.id}`" class="takt-plan-workpackage-legend-train-item-left-rotated" style="grid-gap: 8px;" >
                  <MileStoneStyle 
                    :milestone="m.milestone" type="train"/>
                  <TText :value="m.milestone.name" max_lines="2" />
                </div>
                  
              </div>
            </div>

            <div id="legend-container-left" class="takt-plan-workpackage-legend-left-rotated"
              :style="`width: ${legend_left}px`">
              <div v-for="train, index in trains" :key="`legend-train${index}`"
                class="takt-plan-workpackage-legend-train-left-rotated">
                <TText :text="train.name" />
                <div class="takt-plan-workpackage-legend-train-line"
                  :style="`background-color: ${$vuetify.theme.dark ? 'white' : 'black'};`" />
                <div v-for="wp in getUniqueTWorkPackagesByTrain(train)"
                  :key="`wp-${wp.token}-${wp.icon}-${wp.color}-${wp.name}`"
                  class="takt-plan-workpackage-legend-train-item-left-rotated">
                  <TWorkPackage class="ml-2 mr-2" :workpackage_count="1" :zoom="$store.state.View.taktplan_zoom" :color="calcLegendWPColor(wp, train)"
                    :workpackage="wp" style="flex-shrink: 0;" />
                  <TText :text="wp.name" max_lines="2" />
                </div>
              </div>
            </div>
          <!-- </div> -->

        </div>
      </template>
      <!-- spatial structure -->
      <div v-else style="position: relative; height: 100%">
        <TaktTimeHighLighter v-if="getCurrentTaktIndex(project_id) !== false"
          :index="Math.abs(getCurrentTaktIndex(project_id))"
          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
          z_index="2" />
        <TaktTimeHighLighter v-if="getCurrentTaktIndex(project_id) !== false &&
          getCurrentTaktIndex(project_id) >= 0" :index="getCurrentTaktIndex(project_id) + 1"
          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
          z_index="2" />
        <div style="width: 248px">
          <ProjectStructureTreeTaktplan v-for="site in getUObjects({ type: 'sites', ids: project.sites })"
            :key="`site${site.id}`" :parent="site" :open="!site.closed"
            :child_elements="getChildElements({ parent_type: 'sites', parent_id: site.id })" :sticky_left="0"
            :project_length="getProjectLength(project_id)"
            :project_taktplan_spatial_header_width="project_taktplan_spatial_header_width" :project_id="project_id"
            :parent_color_index="0" :new_milestone="new_milestone" :milestone_selection="milestone_selection"
            :snackbar="snackbar" @parentClicked="
              $event.type === 'element_wrapper' ?
                toggleElementWrappersOpen($event)
                :
                updateUDObject({
                  url: [
                    { [$event.type]: $event.id }
                  ],
                  update: {
                    closed: !$event.closed
                  }
                })" />
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
// import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ProjectMixin } from '@/mixins/Project.mixin.js'
import { TaktPlanMixin } from '@/mixins/TaktPlan.mixin.js'
import { TrainMixin } from '@/mixins/Train.mixin.js'
import { TWaggonMixin } from '@/mixins/TWaggon.mixin.js'
import { TaktAreaMixin } from '@/mixins/TaktArea.mixin.js'
import { TWorkPackageMixin } from '@/mixins/TWorkPackage.mixin.js'
import { FlexBarMixin } from '@/mixins/FlexBar.mixin.js'
import { SideBarMixin } from '@/mixins/SideBar.mixin.js'
import { InfoBoxMixin } from '@/mixins/InfoBox.mixin.js'
import { SwitchMixin } from '@/mixins/Switch.mixin.js'
import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'

import draggable from "vuedraggable";

// import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue'
// import Placeholder from '@/components/ProjectTaktPlan/Placeholder.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
// import ActivatorDelete from '@/components/ProjectTaktPlan/ActivatorDelete.component.vue'
// import ActivatorInsert from '@/components/ProjectTaktPlan/ActivatorInsert.component.vue'
import ActivatorSlider from '@/components/ProjectTaktPlan/ActivatorSlider.component.vue'
// import StandardHover from '@/components/StandardComponents/StandardHover.component.vue'
// import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
// import StandardBadgeMini from '@/components/StandardComponents/StandardBadgeMini.component.vue'
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue';



// import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue'
import TPTrain from '@/views/Project/ProjectTaktPlan/TPTrain.wrapper.vue';

import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'


import TaktTimeHighLighter from '@/components/ProjectTaktPlan/TaktTimeHighLighter.component.vue'
import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue'
import HeaderColumn from '@/components/ProjectTaktPlan/HeaderColumn.component.vue'
import HeaderColumnMonth from '@/components/ProjectTaktPlan/HeaderColumnMonth.component.vue'
import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue'
// import HeaderTrainOpen from '@/components/ProjectTaktPlan/HeaderTrainOpen.component.vue'
import DateCircle from '@/components/ProjectTaktPlan/DateCircle.component.vue'
import HeaderRowStatistics from '@/components/ProjectTaktPlan/HeaderRowStatistics.component.vue'
import StatisticsBackgroundBlurr from '@/components/ProjectTaktPlan/StatisticsBackgroundBlurr.component.vue'
import StatisticsTakt from '@/components/ProjectTaktPlan/StatisticsTakt.component.vue'
import StatisticsBeamTaktSum from '@/components/ProjectTaktPlan/StatisticsBeamTaktSum.component.vue'
import StatisticsBeam from '@/components/ProjectTaktPlan/StatisticsBeam.component.vue'
import StatisticsCard from '@/components/ProjectTaktPlan/StatisticsCard.component.vue'
import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue'
// import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'
// import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue'
import FlexBar from '@/components/ProjectTaktPlan/FlexBar.component.vue'
import SnackBar from '@/components/ProjectTaktPlan/SnackBar.component.vue'

import TText from '@/components/Taktify/TText.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'
import TIconButton from '@/components/Taktify/TIconButton.component.vue'
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue'
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';
import FillableCell from '@/components/WorkPackageWIP/FillableCell.component.vue';
import SnackBarStepItem from '@/modules/WorkPackageWIP/SnackBarStepItem.module.vue';

import MileStonesLane from '@/components/ProjectTaktPlan/MileStonesLane.component.vue'
import MileStone from '@/components/ProjectTaktPlan/MileStone.component.vue'
import MileStoneStyle from '@/components/ProjectTaktPlan/MileStoneStyle.component.vue'

import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue'
import PrintDialog from '@/components/StandardComponents/PrintDialog.component.vue';
// @ is an alias to /src

export default {
  components: {
    draggable,
    TPTrain,
    // TrainHead,
    // Placeholder,
    Activator,
    // ActivatorDelete,
    // ActivatorInsert,
    ActivatorSlider,
    // StandardHover,
    // StandardBadge,
    // StandardBadgeMini,
    // TrainTail,
    TaktTimeHighLighter,
    HeaderRow,
    HeaderColumn,
    HeaderColumnMonth,
    HeaderPlaceholder,
    // HeaderTrainOpen,
    DateCircle,
    HeaderRowStatistics,
    StatisticsBackgroundBlurr,
    StatisticsTakt,
    StatisticsBeamTaktSum,
    StatisticsBeam,
    StatisticsCard,
    StandardOverflowButton,
    // StandardDeleteButton,
    FlexBar,
    SnackBar,
    StandardFlexBox,
    StandardSwitch,
    DisableableInputField,
    // StandardDialog,
    TText,
    TIcon,
    TIconButton,
    ButtonOutlined,
    ToggleCapsule,
    FillableCell,
    SnackBarStepItem,

    MileStonesLane,
    MileStone,
    PopUpOverlay,
    MileStoneStyle,
    PrintDialog,
  },
  mixins: [
    ProjectMixin,
    TaktPlanMixin,
    TrainMixin,
    TWaggonMixin,
    TaktAreaMixin,
    TWorkPackageMixin,
    FlexBarMixin,
    SideBarMixin,
    InfoBoxMixin,
    SwitchMixin,
    MilestonesMixin,
  ],
  created() {
    if (this.$route.params.movie) {
      this.startMovie();
    }
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    // Remove the keydown event listener when the component is destroyed
    // document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  updated() {
    this.updateLegendLeft();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.open_cloudprint) {
      this.project.trains.forEach(train_id => {
        this.$store.dispatch('UltraDev/updateUDObject', {
          url: [
            { trains: train_id }
          ],
          update: {
            closed: this.$store.state.Auth.cloudprint_cache.settings.trains_open.includes(train_id) ? false : true
          }
        })
      })
    }
    if (to.params.histproject_id) {
      if (to.params.movie_playing) {
        let self = this;
        setTimeout(function () {
          self.nextFrame();
        }, 1000 * 5);
        next();
      } else {
        this.$store.dispatch('Ultra/requestUObject', {
          url: [
            { projects: to.params.project_id },
            { histprojects: to.params.histproject_id },
            { showWithEntitiesNormalized: '' }
          ]
        }).then(() => {
          next();
        });
      }
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.leaveEditMode({ project_id: this.project_id })
    this.setValue({ key: 'taktarea_filter', value: '' });
    this.setValue({ key: 'takt_time_filter', value: { active: false, start: 5, end: 11 }}); // 5 and 11 are random default values
    next();
  },
  props: ['project_id', 'milestone_id', 'location'],
  data: () => ({
    date: '',
    weekstart: '',
    takt_time_filter_popup: false,
    show_calendar_edit: false,
    show_statistics: true,
    project_image: '',
    structure_loading: false,
    dragging_train_id: -1,
    legend_left: 0,
    legend_width: 256,
    show_taktarea_filter: false,
    empty_train_waggon_count: 3,
    add_empty_train: false,
    date_circle_value: 'dates',
  }),
  mounted() {
    let taktplan_container = document.getElementById('taktplan');
    let taktplan_zoom = getComputedStyle(document.body).getPropertyValue('--taktplan_zoom');
    let workpackage_width_string = getComputedStyle(document.body).getPropertyValue('--workpackage_width');
    let column_width = parseInt(workpackage_width_string.slice(0, -2)) + 8;
    if (this.getCurrentTaktIndex(this.project_id)) {
      taktplan_container.scrollLeft = this.getCurrentTaktIndex(this.project_id) * column_width * taktplan_zoom;
    }

    this.updateLegendLeft();
  },
  computed: {
    snackbar() {
      return this.$store.state.SnackBar.snackbar;
    },
    snackbar_ifc() {
      return this.$store.state.SnackBarIFC.snackbar;
    },
    snackbar_ifc_element_count(){
      let count = 0;
      if (this.snackbar_ifc.response) {
        for (let i=0; i<this.snackbar_ifc.response.taktareas.length; i++){
          count += this.snackbar_ifc.response.taktareas[i].elements.length;
        }
      }
      return count;
    },
    isProjectEmpty(){
      if( this.project.trains.length > 0){
        return false;
      }
      let groups = this.getTrainsBacklogs(this.project.id)
      for(const group of groups){
        let line_ids = group.wblines
        for(const id of line_ids){
          if(this.getWBWorkpackagesForTaktplan({hist: false, wbline: id}).wbworkpackages.length !== 0){
          return false;
          }
        }
      }
      return true
    },
    project() {
      if (this.location === 'HistProject') {
        return this.getUObject({ type: 'histprojects', id: this.$route.params.histproject_id });
      } else {
        return this.getUObject({ type: 'projects', id: this.project_id });
      }
    },
    trains() {
      if (this.location === 'HistProject') {
        // return this.getUObjects({type: 'histtrains', ids: this.project.histtrains});
        return this.getHistTrainsBacklogs(this.project.id);
      } else {
        return this.getTrainsBacklogs(this.project.id);
      }
    },
    // taktplan_width() {
    //   console.log('teeeest');
    //   return `${document.getElementById('statistics-container').clientWidth}px`;
    // },
    ...mapGetters('Autopilot', [
      'getAutopilots',
    ]),
    ...mapGetters('View', [
      'getTaktplanZoom',
    ]),
    ...mapGetters('Project', [
      'getOwnTWorkPackages',
      'hasProjectPermission',
    ]),
    ...mapGetters('MultiProject', [
      'getMultiProjectsByProject',
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
    ]),
    ...mapGetters('ProjectBacklog', [
      'getTrainsBacklogs',
      'getHistTrainsBacklogs',
      'getWBWorkpackagesForTaktplan'
    ]),
    ...mapGetters('TWorkPackage', [
      'getUniqueTWorkPackagesByTrain',
      'getUniqueTWorkPackagesByProject',
    ]),
    new_milestone() {
      return this.getNewMilestone(this.project_id);
    },
    milestone_selection() {
      return this.getMileStoneSelection({ project_id: this.project_id, milestone_id: this.milestone_id });
    }
  },

  methods: {
    setTaktTimeFilter(active, start, end) {
      // ensure that end > start
      if (start >= end) {
        end = start + 2;
      }
      this.setValue({ key: 'takt_time_filter', value: { active: active, start: start, end: end } });
    },
    getTaktTimeFilterMonthDuration(months, month){
      console.log(months, month);
      const start_index = parseInt(this.$store.state.View.takt_time_filter.start)
      // month.takt_index <= $store.state.View.takt_time_filter.start ? month.duration - 
      if (month.takt_index < start_index) {
        let duration = 0;
        // iterate over months until month.integer = months[i].integer and add duration
        for (let i = 0; i < months.length; i++) {
          if (months[i].integer === month.integer) {
            break;
          }
          duration += months[i].duration;
        }
        console.log('duration', month.duration, start_index + 1, duration, '=', month.duration - (start_index + 1) - duration)
        return month.duration - (start_index + 1) - duration;
      }
      return month.duration;
    },
    shiftDateCircleValue(){
      // dates -> calendar weeks -> takt
      switch (this.date_circle_value) {
        case 'dates':
          this.setShowCalendarWeeks();
          this.date_circle_value = 'calendar_weeks';
          break;
        case 'calendar_weeks':
          this.date_circle_value = 'takt';
          break;
        case 'takt':
          this.date_circle_value = 'dates';
          this.setShowCalendarWeeks();
          break;
      }
      this.setShowMilestones(false);
    },
    getDateCircleValue(takt_time, index) {
      switch (this.date_circle_value) {
        case 'dates':
          return [takt_time.first_day_string, takt_time.last_day_string];
        case 'calendar_weeks':
          return takt_time.calendar_weeks;
        case 'takt':
          return [index + 1];
      }
    },
    calcLegendWPColor(workpackage, train) {
      //flexbar filter
      if (this.getStatisticSettings.filter) {
        if (
          this.wpIsGrey('colors', workpackage.color) ||
          this.wpIsGrey('icons', workpackage.icon) ||
          this.wpIsGrey('status', workpackage.status, workpackage.stop_status) ||
          // this.wpIsGrey('status', workpackage.stop_status) ||
          this.wpIsGrey('trains', train.id) ||
          //stopstatus
          (this.getStatisticSettings.status.length === 1 && this.getStatisticSettings.status.includes('stop') && workpackage.stop_status !== 'stop') ||
          (this.getStatisticSettings.status.length !== 0 && !this.getStatisticSettings.status.includes('stop') && workpackage.stop_status === 'stop')
        ) {
          return 'grey darken-3';
        }
      }
      //show own wps
      if (
        this.isShowOwnWps
        && this.getOwnTWorkPackages(this.project_id).length !== 0
        && !this.getOwnTWorkPackages(this.project_id).includes(workpackage.id)
      ) {
        return 'grey darken-3';
      }
      // take workpackage color
      return false;
    },
    wpIsGrey(settings_key, value, stop_status) {
      if (
        this.getStatisticSettings[settings_key].length !== 0 &&
        !this.getStatisticSettings[settings_key].includes(value)
        //prevent stop status
        && !(this.getStatisticSettings.status.includes('stop') && stop_status === 'stop')
      ) {
        return true;
      } else {
        // if (settings_key === 'status') {

        //   console.log('not grey');
        // }
        return false;
      }
    },
    handleKeyDown(event) {
      // check if the even key code is 27 (esc)
      if (event.keyCode === 27) {
        // Execute your function here
        this.routeToTaktplan();
      }
    },
    getEmptyTrainPayload() {
      let train = {
        name: 'New Train',
        description: '',
        train_start: 0,
        workable_backlog: false,
        position: 1,
        taktareas: [{
          name: 'A',
          description: '',
          taktarea_start: 0,
          square_meter: 0,
          waggons: [],
        }]
      };
      for (let i = 0; i < this.empty_train_waggon_count; i++) {
        train.taktareas[0].waggons.push({status: 'open', work_packages: []});
      }
      return train;
    },
    getCurrentTimesptampString() {
      let today = new Date();
      let year = today.getFullYear();
      let month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      let day = today.getDate().toString().padStart(2, '0');
      let hours = today.getHours().toString().padStart(2, '0');
      let minutes = today.getMinutes().toString().padStart(2, '0');

      // Create the formatted date-time string
      return year + '/' + month + '/' + day + ' - ' + hours + ':' + minutes;
    },
    updateLegendLeft() {

      let width_el = document.getElementById('statistics-container');
      if (!width_el) {
        this.legend_left = 1440;
      } else {
        let width = width_el.clientWidth;
        this.legend_left = width;
      }

    },
    getLargestContainer() {
      // console.log(document.getElementById('taktplan-container'));
      // console.log(document.getElementById('legend-container'));
      if (document.getElementById('taktplan-container') && document.getElementById('legend-container')) {
        let taktplan = document.getElementById('taktplan-container').clientHeight;
        let legend = document.getElementById('legend-container').clientHeight;

        if (taktplan >= legend) {
          return 'taktplan-container';
        }
        else {
          return 'legend-container';
        }
      }
      return 'taktplan-container';
    },
    startMovie() {
      let histprojects = this.getUObjects({ type: 'histprojects' });
      this.setValue({ key: 'histprojects', value: histprojects.map(x => x.id) });
      let self = this;
      setTimeout(function () {
        self.nextFrame();
      }, 1000 * 5);
    },
    nextFrame() {
      let index = this.$store.state.View.histprojects.indexOf(this.$route.params.histproject_id);
      if (index === -1 || index === this.$store.state.View.histprojects.length - 1) {
        this.routeToTaktplan();
      } else {
        let len = this.$store.state.View.histprojects.length;
        if (len > 2) {
          if (index % 2 === 0) {
            for (let i = 0; i < 2; i++) {
              if (5 + 2 + index + i < this.$store.state.View.histprojects.length) {
                this.requestUObject({
                  url: [
                    { projects: this.project_id },
                    { histprojects: this.$store.state.View.histprojects[5 + 2 + index + i] },
                    { showWithEntitiesNormalized: '' }
                  ]
                });
              }
            }
          }
        }
        this.$router.push({
          name: 'HistProjectTaktPlan',
          params: {
            histproject_id: this.$store.state.View.histprojects[index + 1],
            movie_playing: true
          }
        });
      }
    },
    extractStepType() {
      let s = this.snackbar.target_type;
      s = s.substring(1); // remove leading 't'
      s = s.slice(0, -5); // remove trailing 'steps'
      s = s[0].toUpperCase() + s.substring(1); // capitalize first letter
      return s;
    },

    getPosUpDownText() {
      let diff = this.snackbar.position_difference;
      let s = 'Move this step ';
      s += Math.abs(diff);
      s += ' position'
      s += Math.abs(diff) > 1 ? 's ' : ' ';
      s += diff > 0 ? 'up' : 'down';
      return s;
    },

    getPosForwardsBackwardsText(diff, initial) {
      let s = initial || '';
      s += Math.abs(diff);
      s += ' position';
      s += Math.abs(diff) > 1 ? 's ' : ' ';
      s += diff > 0 ? 'forwards' : 'backwards';
      return s;
    },

    getUpdatePositionText() {
      let s = 'Apply this change for ';
      if (this.snackbar.target_type.substring(this.snackbar.target_type.length - 5) === 'steps') {
        s += 'all steps:';
      }
      else if (this.snackbar.target_type === 'tworkpackages') {
        s += 'all workpackages:'
      }
      else if (this.snackbar.target_type === 'twaggons') {
        s += 'all waggons:';
      }
      else {
        'everything:';
      }
      return s;
    },

    getFlexbarToolTip(tooltip) {
      if (this.hasPermission('Flexbar READ')) {
        return tooltip;
      }
      return 'The full FLEX.bar is part of the TAKT.ing PRO.account.';
    },

    getSquareMeter(train, taktarea) {
      if (train.closed) {
        // train
        let square_meters = 0;
        for (var i = 0; i < train.taktareas.length; i++) {
          square_meters += this.getTaktarea(train.taktareas[i]).square_meter;
        }
        return square_meters;
      } else {
        // taktarea
        return parseInt(taktarea.square_meter) !== 0 ? taktarea.square_meter : ''
      }
    },

    addProjectImage() {
      let image_data = new FormData();
      image_data.append('image', this.$refs.project_image.files[0]);
      this.uploadProjectImage({
        project_id: this.$route.params.project_id,
        image: image_data
      })
    },

    ...mapActions('ProjectStructure', [
      'requestProjectElements',
      'toggleElementWrappersOpen',
    ]),
    ...mapActions('Project', [
      'uploadProjectImage'
    ]),
    ...mapActions('ProjectBacklog', [
      'setNewWPPosition'
    ]),
    ...mapActions('Ultra', [
      'requestUObject'
    ]),
    ...mapActions('Autopilot', [
      'clearAutopilots'
    ]),
    ...mapActions('View', [
      'setValue'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarFiltered',
      'updateSnackbarFiltered'
    ]),
    displayNumber(takt_sum) {
      if(takt_sum > 1000000){
        return (takt_sum/1000000).toFixed(2) + ' M'
      }

      if(takt_sum > 100000){
        return (takt_sum/1000).toFixed(1) + ' k'
      }

      if(takt_sum > 1000){
        return (takt_sum/1000).toFixed(2) + ' k'
      }

      return Number.isInteger(takt_sum) ? takt_sum : takt_sum.toFixed(2)
    }
  }
}
</script>

<style>
.taktplan {
  position: absolute;
  width: calc(100% - 8px);
  /* transition: width 0s 200ms; */
  transition: width 0.2s ease-out;
  will-change: width;
  /* transform: translateZ(0); */
}

.grow-x-enter,
.grow-x-leave-to {
  width: 0px;
}

.grow-x-enter-active,
.grow-x-leave-active {
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}

.grow-y-enter,
.grow-y-leave-to {
  height: 0px;
}

.grow-y-enter-active,
.grow-y-leave-active {
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  /* transition: opacity 0.5s ease-in-out; */
}

.zoom-translate-enter,
.zoom-translate-leave-to {
  transform: translate(var(--waggon_offset_x), var(--waggon_offset_y)) scale(0, 0);
}

.zoom-translate-enter-active,
.zoom-translate-leave-active {
  transition: all 0.2s ease-in-out;
}

.zoom-enter,
.zoom-leave-to {
  transform: translate(2px, -3px) scale(0.3, 0.3);
}

.zoom-enter-active,
.zoom-leave-active {
  transition: all 0.2s ease-in-out;
}

.snack-bar-slide-y-enter,
.snack-bar-slide-y-leave-to {
  transform: translate(-50%, calc(100% + 39px));
}

.snack-bar-slide-y-enter-active,
.snack-bar-slide-y-leave-active {
  transition: all 0.2s ease-in-out;
}

.big_black_block {
  height: calc(100vh - 48px - 26px - 62px - 41px - 10px - 31px);
}

.takt-plan-snack-bar-head,
.takt-plan-snack-bar-head>div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.takt-plan-snack-bar-head {
  padding: 0 12px 8px 12px;
}

.takt-plan-snack-bar-body-update-value-from-to-container {
  padding: 8px 16px;
}

.takt-plan-snack-bar-body-update-value-from-to-item {
  display: flex;
  flex-direction: row;
  grid-gap: 8px;
  align-items: center;
}

.takt-plan-snack-bar-footer {
  padding: 6px 24px;
}

.takt-plan-snack-bar-footer-toggle {
  display: flex;
  grid-gap: 8px;
  padding: 8px 0 16px 0;
}

.takt-plan-snack-bar-footer-buttons {
  display: flex;
  justify-content: center;
  grid-gap: 8px;
}

.takt-plan-train-container {
  display: flex;
  flex-direction: column;
}

.takt-plan-workpackage-legend {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: absolute;
}

.takt-plan-workpackage-legend-train {
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
}

.takt-plan-workpackage-legend-train-line {
  width: 100%;
  height: 1px;
  margin: 4px 0;
}

.takt-plan-workpackage-legend-train-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.takt-plan-workpackage-legend-left {
  display: flex;
  flex-direction: row;
}


/* .takt-plan-workpackage-legend-left-rotated {
  display: flex;
  flex-direction: column;
} */

.takt-plan-workpackage-legend-left-rotated {
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  /* position: absolute; */
}

.takt-plan-workpackage-legend-train-left-rotated {
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  /* height: 222px; */
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
}

.takt-plan-workpackage-legend-train-item-left-rotated {
  display: flex;
  align-items: center;
  width: 200px;
  height: 50px;
  border-bottom: 0.1px dotted #ffffff3d;
}

.filter-taktareas-input {
  position: fixed;
  /* left: 10px; */
  top: 80px;
  /* max-width: 200px !important; */
  /* width: 205px !important; */
  z-index: 1015;
  background-color: #212121;
}
</style>
